export default "__VITE_ASSET__DkYlHcis__"